// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file modules/apiengine/services/login/security.proto (package aurora.core.apiengine.loginv1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file modules/apiengine/services/login/security.proto.
 */
export const file_modules_apiengine_services_login_security: GenFile = /*@__PURE__*/
  fileDesc("Ci9tb2R1bGVzL2FwaWVuZ2luZS9zZXJ2aWNlcy9sb2dpbi9zZWN1cml0eS5wcm90bxIdYXVyb3JhLmNvcmUuYXBpZW5naW5lLmxvZ2ludjEiDwoNTG9nb3V0UmVxdWVzdCIQCg5Mb2dvdXRSZXNwb25zZSIXChVHZXRTU09TZXR0aW5nc1JlcXVlc3QiWQoWR2V0U1NPU2V0dGluZ3NSZXNwb25zZRIWCgxtZXRhZGF0YV91cmwYASABKAlIABIbChFtZXRhZGF0YV9maWxlbmFtZRgCIAEoCUgAQgoKCG1ldGFkYXRhIoEBChVTZXRTU09TZXR0aW5nc1JlcXVlc3QSFgoMbWV0YWRhdGFfdXJsGAEgASgJSAASRAoNbWV0YWRhdGFfZmlsZRgCIAEoCzIrLmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5sb2dpbnYxLk1ldGFkYXRhRmlsZUgAQgoKCG1ldGFkYXRhIi8KDE1ldGFkYXRhRmlsZRIRCglmaWxlX25hbWUYASABKAkSDAoEZmlsZRgCIAEoDCIYChZTZXRTU09TZXR0aW5nc1Jlc3BvbnNlIhkKF1JlbW92ZVNTT1NldHRpbmdSZXF1ZXN0IhoKGFJlbW92ZVNTT1NldHRpbmdSZXNwb25zZTKFBAoPU2VjdXJpdHlTZXJ2aWNlEmcKBkxvZ291dBIsLmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5sb2dpbnYxLkxvZ291dFJlcXVlc3QaLS5hdXJvcmEuY29yZS5hcGllbmdpbmUubG9naW52MS5Mb2dvdXRSZXNwb25zZSIAEn8KDkdldFNTT1NldHRpbmdzEjQuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmxvZ2ludjEuR2V0U1NPU2V0dGluZ3NSZXF1ZXN0GjUuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmxvZ2ludjEuR2V0U1NPU2V0dGluZ3NSZXNwb25zZSIAEn8KDlNldFNTT1NldHRpbmdzEjQuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmxvZ2ludjEuU2V0U1NPU2V0dGluZ3NSZXF1ZXN0GjUuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmxvZ2ludjEuU2V0U1NPU2V0dGluZ3NSZXNwb25zZSIAEoYBChFSZW1vdmVTU09TZXR0aW5ncxI2LmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5sb2dpbnYxLlJlbW92ZVNTT1NldHRpbmdSZXF1ZXN0GjcuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmxvZ2ludjEuUmVtb3ZlU1NPU2V0dGluZ1Jlc3BvbnNlIgBCQFo+Z2l0bGFiLnBydmJsLmNvbS9hdXJvcmEvY29yZS9zcmMvbW9kdWxlcy9hcGllbmdpbmUvYXBpL2xvZ2ludjFiBnByb3RvMw");

/**
 * @generated from message aurora.core.apiengine.loginv1.LogoutRequest
 */
export type LogoutRequest = Message<"aurora.core.apiengine.loginv1.LogoutRequest"> & {
};

/**
 * Describes the message aurora.core.apiengine.loginv1.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_security, 0);

/**
 * @generated from message aurora.core.apiengine.loginv1.LogoutResponse
 */
export type LogoutResponse = Message<"aurora.core.apiengine.loginv1.LogoutResponse"> & {
};

/**
 * Describes the message aurora.core.apiengine.loginv1.LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_security, 1);

/**
 * @generated from message aurora.core.apiengine.loginv1.GetSSOSettingsRequest
 */
export type GetSSOSettingsRequest = Message<"aurora.core.apiengine.loginv1.GetSSOSettingsRequest"> & {
};

/**
 * Describes the message aurora.core.apiengine.loginv1.GetSSOSettingsRequest.
 * Use `create(GetSSOSettingsRequestSchema)` to create a new message.
 */
export const GetSSOSettingsRequestSchema: GenMessage<GetSSOSettingsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_security, 2);

/**
 * @generated from message aurora.core.apiengine.loginv1.GetSSOSettingsResponse
 */
export type GetSSOSettingsResponse = Message<"aurora.core.apiengine.loginv1.GetSSOSettingsResponse"> & {
  /**
   * @generated from oneof aurora.core.apiengine.loginv1.GetSSOSettingsResponse.metadata
   */
  metadata: {
    /**
     * @generated from field: string metadata_url = 1;
     */
    value: string;
    case: "metadataUrl";
  } | {
    /**
     * @generated from field: string metadata_filename = 2;
     */
    value: string;
    case: "metadataFilename";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message aurora.core.apiengine.loginv1.GetSSOSettingsResponse.
 * Use `create(GetSSOSettingsResponseSchema)` to create a new message.
 */
export const GetSSOSettingsResponseSchema: GenMessage<GetSSOSettingsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_security, 3);

/**
 * @generated from message aurora.core.apiengine.loginv1.SetSSOSettingsRequest
 */
export type SetSSOSettingsRequest = Message<"aurora.core.apiengine.loginv1.SetSSOSettingsRequest"> & {
  /**
   * @generated from oneof aurora.core.apiengine.loginv1.SetSSOSettingsRequest.metadata
   */
  metadata: {
    /**
     * @generated from field: string metadata_url = 1;
     */
    value: string;
    case: "metadataUrl";
  } | {
    /**
     * @generated from field: aurora.core.apiengine.loginv1.MetadataFile metadata_file = 2;
     */
    value: MetadataFile;
    case: "metadataFile";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message aurora.core.apiengine.loginv1.SetSSOSettingsRequest.
 * Use `create(SetSSOSettingsRequestSchema)` to create a new message.
 */
export const SetSSOSettingsRequestSchema: GenMessage<SetSSOSettingsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_security, 4);

/**
 * @generated from message aurora.core.apiengine.loginv1.MetadataFile
 */
export type MetadataFile = Message<"aurora.core.apiengine.loginv1.MetadataFile"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: bytes file = 2;
   */
  file: Uint8Array;
};

/**
 * Describes the message aurora.core.apiengine.loginv1.MetadataFile.
 * Use `create(MetadataFileSchema)` to create a new message.
 */
export const MetadataFileSchema: GenMessage<MetadataFile> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_security, 5);

/**
 * @generated from message aurora.core.apiengine.loginv1.SetSSOSettingsResponse
 */
export type SetSSOSettingsResponse = Message<"aurora.core.apiengine.loginv1.SetSSOSettingsResponse"> & {
};

/**
 * Describes the message aurora.core.apiengine.loginv1.SetSSOSettingsResponse.
 * Use `create(SetSSOSettingsResponseSchema)` to create a new message.
 */
export const SetSSOSettingsResponseSchema: GenMessage<SetSSOSettingsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_security, 6);

/**
 * @generated from message aurora.core.apiengine.loginv1.RemoveSSOSettingRequest
 */
export type RemoveSSOSettingRequest = Message<"aurora.core.apiengine.loginv1.RemoveSSOSettingRequest"> & {
};

/**
 * Describes the message aurora.core.apiengine.loginv1.RemoveSSOSettingRequest.
 * Use `create(RemoveSSOSettingRequestSchema)` to create a new message.
 */
export const RemoveSSOSettingRequestSchema: GenMessage<RemoveSSOSettingRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_security, 7);

/**
 * @generated from message aurora.core.apiengine.loginv1.RemoveSSOSettingResponse
 */
export type RemoveSSOSettingResponse = Message<"aurora.core.apiengine.loginv1.RemoveSSOSettingResponse"> & {
};

/**
 * Describes the message aurora.core.apiengine.loginv1.RemoveSSOSettingResponse.
 * Use `create(RemoveSSOSettingResponseSchema)` to create a new message.
 */
export const RemoveSSOSettingResponseSchema: GenMessage<RemoveSSOSettingResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_security, 8);

/**
 * @generated from service aurora.core.apiengine.loginv1.SecurityService
 */
export const SecurityService: GenService<{
  /**
   * @generated from rpc aurora.core.apiengine.loginv1.SecurityService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof LogoutResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.loginv1.SecurityService.GetSSOSettings
   */
  getSSOSettings: {
    methodKind: "unary";
    input: typeof GetSSOSettingsRequestSchema;
    output: typeof GetSSOSettingsResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.loginv1.SecurityService.SetSSOSettings
   */
  setSSOSettings: {
    methodKind: "unary";
    input: typeof SetSSOSettingsRequestSchema;
    output: typeof SetSSOSettingsResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.loginv1.SecurityService.RemoveSSOSettings
   */
  removeSSOSettings: {
    methodKind: "unary";
    input: typeof RemoveSSOSettingRequestSchema;
    output: typeof RemoveSSOSettingResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_modules_apiengine_services_login_security, 0);

